export const processManagerApiUrl =
	process.env.VUE_APP_API_HOSPITAL_PARTNERS_URL;
export const siteUrl = process.env.VUE_APP_SITE_URL;
export const keycloackAuthorityUrl =
	process.env.VUE_APP_KEYCLOACK_AUTHORITY_URL;
export const keycloackClientIdUrl = process.env.VUE_APP_KEYCLOACK_CLIENT_ID_URL;


export default {
	processManagerApiUrl,
	siteUrl,
	keycloackAuthorityUrl,
	keycloackClientIdUrl,
};